import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.self.js";
import { getSpeechModelList, composeSpeech } from '@/api/modules/personal';
import qs from 'qs';
import CryptoJS from 'crypto-js';
export const mixin = {
  data() {
    return {
      demoText: '',
      modelList: [],
      composeType: '',
      selectedModel: '',
      speed: 100,
      intonation: 0,
      volumn: 50,
      status: 'uncomposed',
      female: require('@/assets/images/technology/TextToSpeech/text-to-speech-product-female.png'),
      male: require('@/assets/images/technology/TextToSpeech/text-to-speech-product-male.png'),
      audioSource: '',
      speechModel: {
        app_id: '9C7D63A225A241CF8220210115103227',
        app_key: 'E7DE7D6D1A0D1DD90FD8BA620F884F32'
      }
    };
  },
  computed: {
    curModels() {
      const result = this.modelList.find(item => item.name === this.composeType);
      return result ? result.datas : [];
    },
    watchParams() {
      const {
        selectedModel,
        demoText,
        speed,
        intonation,
        volumn
      } = this;
      return {
        selectedModel,
        demoText,
        speed,
        intonation,
        volumn
      };
    }
  },
  watch: {
    composeType() {
      var _this$modelList$find;
      this.selectedModel = this.curModels.length > 0 ? this.curModels[0].model_code : '';
      this.demoText = ((_this$modelList$find = this.modelList.find(item => item.name === this.composeType)) === null || _this$modelList$find === void 0 ? void 0 : _this$modelList$find.text) || '';
    },
    watchParams() {
      this.onStatus();
    }
  },
  methods: {
    selectModel(model) {
      this.selectedModel = model.model_code;
      this.status = 'uncomposed';
    },
    onStatus() {
      this.status = 'uncomposed';
      const audio = document.querySelector('audio');
      audio && audio.pause();
    },
    compose() {
      this.status = 'composing';
      const ts = Date.now();
      const sha1 = CryptoJS.HmacSHA1(CryptoJS.MD5(this.speechModel.app_id + ts).toString(), this.speechModel.app_key);
      const signature = CryptoJS.enc.Base64.stringify(sha1);
      const params = {
        authorization: window.btoa(`app_id:${this.speechModel.app_id},ts:${ts},signature:${signature}`),
        text: this.demoText,
        voice: this.selectedModel,
        speed: this.speed,
        pitch: this.intonation,
        volumn: this.volumn,
        voiceType: 0
      };
      composeSpeech(qs.stringify(params)).then(res => {
        if (!res || !res.data) {
          this.status = 'uncomposed';
          _message.error('合成失败，请稍后重试');
          return;
        }
        if (params.voice !== this.selectedModel) {
          return;
        }
        const audio = document.querySelector('audio');
        if (audio) {
          audio.src = `data:audio/x-wav;base64,${res.data.voiceData}`;
          audio.onended = function () {
            this.stopPlay();
          };
        }
        self.status = 'playing';
        audio && audio.play();
      });
    },
    stopPlay() {
      const audio = document.querySelector('audio');
      this.status = 'pause';
      audio && audio.pause();
    },
    continuePlay() {
      const audio = document.querySelector('audio');
      this.status = 'playing';
      audio && audio.play();
    },
    getModelList() {
      getSpeechModelList(qs.stringify(this.speechModel)).then(res => {
        if ((res === null || res === void 0 ? void 0 : res.status_code) === 0) {
          const data = res.data;
          const lastModel = data.pop();
          data.unshift(lastModel);
          this.modelList = data;
          this.composeType = this.modelList[0].name;
        }
      });
    }
  },
  mounted() {
    this.getModelList();
  }
};